import {IThemeAttributes} from '@toolify/client/src/modules/theme/types/IThemeAttributes'

export const THEME_ATTRIBUTE_NAMES: (keyof IThemeAttributes)[] = [
  'data-theme',
  'data-lm-sidebar',
  'data-lm-palette',
]

// Ustawia komplet atrybutow motywu na elemencie i usuwa te, ktorych motyw nie uzywa (np. data-lm-* po
// przejsciu z light-modern na Fiord Night)
export function applyThemeAttributes(element: Element, attributes: Partial<IThemeAttributes>): void {
  for (const attributeName of THEME_ATTRIBUTE_NAMES) {
    const value = attributes[attributeName]
    if (value) {
      element.setAttribute(attributeName, value)
    } else {
      element.removeAttribute(attributeName)
    }
  }
}

// Odczyt kompletu z elementu (domyslnie <html>) - np. do przekazania motywu do okna plywajacych powiadomien
export function readThemeAttributes(element: Element = document.documentElement): Partial<IThemeAttributes> {
  const attributes: Partial<IThemeAttributes> = {}
  for (const attributeName of THEME_ATTRIBUTE_NAMES) {
    const value = element.getAttribute(attributeName)
    if (value) {
      (attributes as Record<string, string>)[attributeName] = value
    }
  }
  return attributes
}
